<template>
  <div id="analysisHistory" class="animated fadeIn h-100">
    <b-row class="h-100">
      <div id="Loader" v-if="LoadYn">
        <div class="spinner-bar">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <b-col style="flex: 0 0 20%; max-width: 20%" class="tree pr20">
        <b-card
          class="h-100 black-border1"
          body-class="h-100 p10"
          header-tag="header"
        >
          <h6
            slot="header"
            class="searchBox"
            style="justify-content: space-between; padding: 0"
          >
            차트 조회 옵션
            <div>
              <b-button
                class="resetBtn w35 py5 px0"
                style="border-radius: 5px; margin-top: 5px"
                @click="openSetting"
                :disabled="search.stid === null"
                ><i class="fas fa-cog mr0"></i
              ></b-button>
            </div>
          </h6>
          <b-form @submit.prevent="getData" class="chartOptions">
            <b-row>
              <b-col>
                <label>프로젝트</label>
                <b-form-select
                  v-model="search.projectid"
                  :options="search.projectidOptions"
                  @change="getStidList"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>구조물</label>
                <vue-select
                  class="select-container w200"
                  v-model="search.stid"
                  :options="search.stidOptions"
                  @input="changeStId"
                  :reduce="(a) => a.value"
                  label="text"
                  :clearable="false"
                  required
                ></vue-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>디바이스</label>
                <b-form-select
                  v-model="search.device"
                  :options="search.deviceOptions"
                ></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>시작 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.startDate"
                  :max="search.endDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>종료 일자</label>
                <b-form-input
                  type="date"
                  v-model="search.endDate"
                  :min="search.startDate"
                  required
                ></b-form-input>
              </b-col>
            </b-row>
            <div class="btnGrp">
              <div class="jcse">
                <b-button
                  class="full-searchBtn"
                  type="submit"
                  :disabled="search.btnDisabled"
                  >조회</b-button
                >
                <b-button
                  class="full-searchBtn"
                  @click="reCheckAnalysis"
                  :disabled="search.btnDisabled"
                  v-if="getUserAuth === 'AD'"
                  >재분석</b-button
                >
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
      <b-col style="flex: 0 0 80%; max-width: 80%" class="cont">
        <b-row class="h-100 chartarea">
          <b-col class="col-12">
            <b-card class="border0 main-body" body-class="h-100">
              <b-row
                class="pb10"
                style="height: calc(100vh - 115px) !important"
              >
                <b-col>
                  <button
                    class="tabBtn"
                    :class="fftTabActiveClass"
                    @click="changeFftTab"
                  >
                    평균 FFT 분석
                  </button>
                  <button
                    class="tabBtn"
                    :class="ssiOctaveTabActiveClass"
                    @click="changeSsiOctaveTab"
                  >
                    SSI Octave 분석
                  </button>
                  <button
                    class="tabBtn"
                    :class="ssiCovTabActiveClass"
                    @click="changeSsiCovTab"
                    disabled
                  >
                    SSICov 분석
                  </button>

                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                    v-if="isFftTab"
                  >
                    <h6 slot="header">평균 FFT 분석 이력 결과</h6>
                    <div
                      style="
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          height: calc(100% - 230px);
                        "
                      >
                        <div
                          style="display: flex; flex-direction: column; flex: 6"
                        >
                          <div class="panelTitle">평균 FFT</div>
                          <div
                            id="fftAvgChart"
                            class="graph panelContent"
                          ></div>
                          <div class="panelTitle">Peak 주파수</div>
                          <div
                            id="fftPeakChart"
                            class="graph panelContent"
                          ></div>
                        </div>

                        <div
                          style="flex: 4; display: flex; flex-direction: column"
                        >
                          <div class="panelTitle">
                            Clustering 분석
                            <button
                              style="
                                float: right;
                                border: none;
                                background-color: transparent;
                              "
                              @click="openFftClusteringModal"
                              :disabled="fftClDatas.length == 0"
                            >
                              <i class="fas fa-expand" style="color: white"></i>
                            </button>
                          </div>
                          <div
                            class="panelContent"
                            style="
                              display: flex;
                              flex-direction: column;
                              flex: 1;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                flex: 5;
                              "
                            >
                              <div id="fftClChart" class="graph"></div>
                            </div>
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                flex: 5;
                              "
                            >
                              <div
                                class="sub-title"
                                style="flex: 2; padding-right: 10px"
                              >
                                <b-form-select
                                  v-model="clusterHistogramIdx"
                                  :options="clusterHistogramOptions"
                                  @change="changeClusterHistogramData"
                                  required
                                ></b-form-select>
                              </div>
                              <div id="fftClHistogram" class="graph"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="panelTitle">Clustering 통계</div>
                      <div class="panelContent" style="height: 230px">
                        <ag-grid-vue
                          class="ag-theme-balham grid"
                          :gridOptions="fftClStatGridOptions"
                        ></ag-grid-vue>
                      </div>
                    </div>
                  </b-card>

                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                    v-else-if="isSsiOctaveTab"
                  >
                    <h6 slot="header">SSI Octave 분석 이력 결과</h6>
                    <div class="h-60">
                      <div style="display: flex; height: 100%">
                        <div style="width: 50%">
                          <div class="panelTitle">{{ freqChartTitle }}</div>
                          <div
                            id="ssiOctaveFreqChart"
                            class="graph panelContent"
                          ></div>
                        </div>
                        <div style="width: 50%">
                          <div class="panelTitle">{{ dampChartTitle }}</div>
                          <div
                            id="ssiOctaveDampChart"
                            class="graph panelContent"
                          ></div>
                        </div>
                      </div>
                    </div>
                    <div class="h-40">
                      <div style="display: flex; height: 100%">
                        <div style="width: 50%; height: 100%">
                          <div class="panelTitle">SSI Octave 분석</div>
                          <ag-grid-vue
                            class="w-100 ag-theme-balham grid"
                            :gridOptions="ssiOctaveGridOptions"
                          ></ag-grid-vue>
                        </div>
                        <div style="width: 50%; height: 100%">
                          <div class="panelTitle">Clustering 분석</div>
                          <div
                            class="panelContent"
                            style="
                              height: calc(100% - 40px);
                              display: flex;
                              flex-direction: column;
                              flex: 1;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                flex: 5;
                              "
                            >
                              <div id="ssiOctClustChart" class="graph"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-card
                    class="h-100 default-border1"
                    body-class="h-100 p-0"
                    header-tag="header"
                    v-else
                  >
                    <h6 slot="header">SSICov 분석 이력 결과</h6>
                    <div
                      style="
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                      "
                    >
                      <div style="display: flex; flex-direction: row; flex: 1">
                        <div
                          style="display: flex; flex-direction: column; flex: 1"
                        >
                          <div class="panelTitle">Peak 주파수</div>
                          <div
                            id="ssiFreqChart"
                            class="graph panelContent"
                          ></div>
                        </div>

                        <div
                          style="display: flex; flex-direction: column; flex: 1"
                        >
                          <div class="panelTitle">Peak Damping</div>
                          <div
                            id="ssiDampingChart"
                            class="graph panelContent"
                          ></div>
                        </div>
                      </div>

                      <div
                        style="display: flex; flex-direction: column; flex: 1"
                      >
                        <div class="panelTitle">Clustering 분석</div>
                        <div
                          class="panelContent"
                          style="display: flex; flex-direction: row; flex: 1"
                        >
                          <div
                            id="ssiClChart"
                            class="graph"
                            style="flex: 3"
                          ></div>
                          <ag-grid-vue
                            class="ag-theme-balham grid"
                            style="flex: 7"
                            :gridOptions="ssiClStatGridOptions"
                          ></ag-grid-vue>
                        </div>
                      </div>

                      <div style="display: flex; flex-direction: row; flex: 1">
                        <div
                          style="display: flex; flex-direction: column; flex: 1"
                        >
                          <div class="panelTitle">충격계수</div>
                          <div id="ssiIfChart" class="graph panelContent"></div>
                        </div>

                        <div
                          style="display: flex; flex-direction: column; flex: 1"
                        >
                          <div class="panelTitle">충격계수 이력</div>
                          <div id="ssiIfHist" class="graph panelContent"></div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal
      id="analysisHistoryModal"
      title="분석 설정"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <analysis-history-modal
        :stid="search.stid"
        :bridgeData="bridgeData"
        @setBridgeInfo="getBridgeInfo"
      ></analysis-history-modal>
    </b-modal>
    <b-modal
      id="fftClusteringModal"
      title="Clustering 분석"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <fft-clustering-modal :clusteringData="fftClDatas">
      </fft-clustering-modal>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import AnalysisHistoryModal from "./AnalysisHistoryModal";
import FftClusteringModal from "./FftClusteringModal";
import { AgGridVue } from "ag-grid-vue";
import utils from "../common/utils";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import chartUtil from "../common/chartUtil";
import { initialiseAgGridWithWebComponents } from "ag-grid";
var Plotly = require("plotly.js/dist/plotly.min.js");

export default {
  components: {
    AnalysisHistoryModal,
    FftClusteringModal,
    AgGridVue,
    VueSelect,
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getTreeGridApi",
      "getAlertOptions",
      "getConfirmOptions",
      "getSelectedDataProjectid",
      "getSelectedDataStid",
      "getSelectedDataStartDate",
      "getSelectedDataEndDate",
    ]),
  },
  data() {
    return {
      search: {
        projectid: null,
        projectidOptions: [{ value: null, text: "선택" }],
        stid: null,
        stidOptions: [{ value: null, text: "선택" }],
        device: null,
        deviceOptions: [{ value: null, text: "전체" }],
        startDate: null,
        endDate: null,
        btnDisabled: false,
      },
      bridgeData: {
        rd: null,
        rdMm: null,
        rmf: null,
        rmfMm: null,
        sl: null,
        ssiFs: null,
        ssiMaxrow: null,
        ssiStablevel: null,
        ssiOrders: null,
        ssiOrder: null,
        ssiStabfreq: null,
        ssiDamping: null,
        ssiMac: null,
        ssiModescale: null,
        ssiProbthr: null,
        ssiScalingxi: null,
        ssiScalingmac: null,
        ssiOmegan: null,
        clusteringCnt: null,
        ssiTargetFreqNum: null,
        ssiX: null,
        ssiAxis: null,
        ssiFreUpperBnd: null,
        ssiFreLowerBnd: null,

        fftavgPeakCnt: null,
        fftavgFreqRangeStart: null,
        fftavgFreqRangeEnd: null,
        fftavgClusterCnt: null,
        fftavgNumOfData: null,
        fftavgOverlap: null,
        ssiFreqRangeStart: null,
        ssiFreqRangeEnd: null,
        ssiClusterCnt: null,
      },
      clusterHistogramIdx: null,
      clusterHistogramOptions: [],
      clusterHistogramDatas: [],
      fftClDatas: [],
      fftClInfo: null,
      fftClStatGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      ssiOctaveGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      ssiClStatGridOptions: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        onRowClicked: (params) => {},
        onRowDoubleClicked: (params) => {},
        rowHeight: 35,
        headerHeight: 35,
      },
      allDatas: null,
      fftTabActiveClass: null,
      ssiOctaveTabActiveClass: null,
      ssiCovTabActiveClass: null,
      isFftTab: true,
      isSsiOctaveTab: false,
      LoadYn: false,
      freqChartTitle: "Frequency",
      dampChartTitle: "Damping",
    };
  },
  created() {
    this.getProjectList();

    if (this.getSelectedDataStid) {
      this.search.stid = this.getSelectedDataStid;
      this.getDeviceId();
      this.getBridgeInfo();
    }
  },
  mounted() {
    this.search.startDate = moment().add(-15, "day").format("YYYY-MM-DD");
    this.search.endDate = moment().format("YYYY-MM-DD");

    if (this.getSelectedDataStartDate) {
      this.search.startDate = this.getSelectedDataStartDate;
    }
    if (this.getSelectedDataEndDate) {
      this.search.endDate = this.getSelectedDataEndDate;
    }

    this.changeFftTab();
  },
  methods: {
    ...mapMutations([
      "setAlertTitle",
      "setConfirmTitle",
      "setSelectedDataProjectid",
      "setSelectedDataStid",
      "setSelectedDataStartDate",
      "setSelectedDataEndDate",
    ]),
    openSetting() {
      this.$bvModal.show("analysisHistoryModal");
    },
    openFftClusteringModal() {
      this.$bvModal.show("fftClusteringModal");
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/stat/getProjectList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].projectid,
                text: data[i].projectname,
              });
            }
            this.search.projectidOptions = options;
            if (this.getSelectedDataProjectid) {
              this.search.projectid = this.getSelectedDataProjectid;
              this.getStidList();
            } else this.search.projectid = null;
          } else {
            this.setAlertTitle("프로젝트 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeStId() {
      this.getDeviceId();
      this.getBridgeInfo();
    },
    getStidList() {
      var reqBody = {
        projectid: this.search.projectid,
        fromAnalysisHistory: "Y",
      };
      this.$http
        .post("/sensor/getStidList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            let options = [{ value: null, text: "선택" }];
            for (let i = 0; i < data.length; i++) {
              options.push({
                value: data[i].stid,
                text: data[i].stname,
              });
            }
            this.search.stidOptions = options;

            if (options.length > 0) {
              if (options[0].value) {
                this.search.stid = options[0].value;
              } else {
                this.search.stid = options[1].value;
              }
              this.getDeviceId();
              this.getBridgeInfo();
            }
          } else {
            this.setAlertTitle("구조물 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDeviceId() {
      var reqBody = {
        stid: this.search.stid,
        devicetype: "1",
      };
      this.$http
        .post("/sensor/getDeviceId", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var devlist = res.data.data;
            var options = [{ value: null, text: "전체" }];
            for (let i = 0; i < devlist.length; i++) {
              options.push({
                value: devlist[i].deviceid,
                text: devlist[i].devicename,
              });
            }
            this.search.device = null;
            this.search.deviceOptions = options;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getBridgeInfo() {
      let reqBody = {
        stid: this.search.stid,
        devicetype: "1",
      };
      this.$http
        .post("/analysisHistory/getBridgeInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let bridgeInfo = res.data.data;
            this.bridgeData.rd = bridgeInfo.RD;
            this.bridgeData.rdMm = bridgeInfo.RD_MM;
            this.bridgeData.rmf = bridgeInfo.RMF;
            this.bridgeData.rmfMm = bridgeInfo.RMF_MM;
            this.bridgeData.sl = bridgeInfo.SL;
            this.bridgeData.ssiFs = bridgeInfo.ssi_fs;
            this.bridgeData.ssiMaxrow = bridgeInfo.ssi_maxrow;
            this.bridgeData.ssiStablevel = bridgeInfo.ssi_stablevel;
            this.bridgeData.ssiOrder = bridgeInfo.ssi_order;
            this.bridgeData.ssiOrders = bridgeInfo.ssi_orders;
            this.bridgeData.ssiStabfreq = bridgeInfo.ssi_stabfreq;
            this.bridgeData.ssiDamping = bridgeInfo.ssi_damping;
            this.bridgeData.ssiMac = bridgeInfo.ssi_mac;
            this.bridgeData.ssiModescale = bridgeInfo.ssi_modescale;
            this.bridgeData.ssiProbthr = bridgeInfo.ssi_probthr;
            this.bridgeData.ssiScalingxi = bridgeInfo.ssi_scalingxi;
            this.bridgeData.ssiOmegan = bridgeInfo.ssi_omegan;
            this.bridgeData.ssiScalingmac = bridgeInfo.ssi_scalingmac;
            this.bridgeData.clusteringCnt = bridgeInfo.clustering_cnt;
            this.bridgeData.ssiTargetFreqNum = bridgeInfo.ssi_target_freq_num;
            this.bridgeData.ssiX = bridgeInfo.ssi_x;
            this.bridgeData.ssiAxis = bridgeInfo.ssi_axis;
            this.bridgeData.ssiFreUpperBnd = bridgeInfo.ssi_fre_upperbnd;
            this.bridgeData.ssiFreLowerBnd = bridgeInfo.ssi_fre_lowerbnd;

            this.bridgeData.fftavgPeakCnt = bridgeInfo.fftavg_peakcnt;
            this.bridgeData.fftavgFreqRangeStart =
              bridgeInfo.fftavg_freqrangestart;
            this.bridgeData.fftavgFreqRangeEnd = bridgeInfo.fftavg_freqrangeend;
            this.bridgeData.fftavgClusterCnt = bridgeInfo.fftavg_clustercnt;
            this.bridgeData.fftavgNumOfData = bridgeInfo.fftavg_numofdata;
            this.bridgeData.fftavgOverlap = bridgeInfo.fftavg_overlap;

            this.bridgeData.ssiFreqRangeStart = bridgeInfo.ssi_freqrangestart;
            this.bridgeData.ssiFreqRangeEnd = bridgeInfo.ssi_freqrangeend;
            this.bridgeData.ssiClusterCnt = bridgeInfo.ssi_clustercnt;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    changeFftTab() {
      this.initData();
      this.fftTabActiveClass = "tabBtn_active";
      this.ssiOctaveTabActiveClass = null;
      this.ssiCovTabActiveClass = null;
      this.isFftTab = true;
      this.isSsiOctaveTab = false;
      this.$nextTick(() => {
        this.initData();
        this.setData();
      });
    },
    changeSsiOctaveTab() {
      this.initData();
      this.fftTabActiveClass = null;
      this.ssiOctaveTabActiveClass = "tabBtn_active";
      this.ssiCovTabActiveClass = null;
      this.isFftTab = false;
      this.isSsiOctaveTab = true;
      this.$nextTick(() => {
        this.initData();
        this.setData();
      });
    },
    changeSsiCovTab() {
      this.initData();
      this.fftTabActiveClass = null;
      this.ssiOctaveTabActiveClass = null;
      this.ssiCovTabActiveClass = "tabBtn_active";
      this.isFftTab = false;
      this.isSsiOctaveTab = false;
      this.$nextTick(() => {
        this.initData();
        this.setData();
      });
    },
    getData() {
      if (this.search.stid === null && this.search.device === null) return;

      var deviceId = null;
      if (this.search.device) {
        var deviceSplit = String(this.search.device).split("/");
        deviceId = deviceSplit[1];
      }

      var reqBody = {
        st_id: this.search.stid,
        device_id: deviceId,
        st_time: moment(this.search.startDate).format("YYYYMMDD"),
        ed_time: moment(this.search.endDate).format("YYYYMMDD"),
      };

      if (this.isSsiOctaveTab) {
        reqBody.Target_Freq_Num = this.ssiTargetFreqNum;
        reqBody.Fre_lowerBnd = this.ssiFreLowerBnd;
        reqBody.Fre_UpperBnd = this.ssiFreUpperBnd;
        reqBody.FS = this.FS;
        reqBody.SSI_order = this.ssiOrder;
        reqBody.SSI_x = this.ssiX;
        reqBody.axis = this.ssiAxis;
      }

      this.setSelectedDataProjectid(this.search.projectid);
      this.setSelectedDataStid(this.search.stid);
      this.setSelectedDataStartDate(this.search.startDate);
      this.setSelectedDataEndDate(this.search.endDate);

      this.search.btnDisabled = true;
      this.LoadYn = true;
      this.allDatas = null;
      this.initData();

      this.$http
        .post("/analysisHistory/getData", reqBody, { timeout: 600000 })
        .then((res) => {
          this.LoadYn = false;
          if (res.data.resultyn === "Y") {
            this.search.btnDisabled = false;

            if (res.data.errormsg != null && res.data.errormsg.length > 0) {
              this.setAlertTitle();
              this.$bvModal
                .msgBoxOk(res.data.data.error_msg, this.getAlertOptions)
                .then((value) => {})
                .catch((err) => {
                  console.error(err);
                });
              return;
            }
            this.allDatas = res.data.data;
            this.setData();
          } else {
            this.search.btnDisabled = false;
            this.setAlertTitle();

            let errorMsg = "관리자에게 문의하세요";
            if (res.data.errormsg != null && res.data.errormsg.length > 0) {
              errorMsg = res.data.errormsg;
            }

            this.$bvModal
              .msgBoxOk(errorMsg, this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          this.search.btnDisabled = false;
          this.LoadYn = false;
          console.error(err);
        });
    },
    initData() {
      if (this.isFftTab) {
        Plotly.purge("fftAvgChart");
        Plotly.purge("fftPeakChart");
        Plotly.purge("fftClChart");
        this.clusterHistogramIdx = null;
        this.clusterHistogramDatas = [];
        this.clusterHistogramOptions = [];
        Plotly.purge("fftClHistogram");
      } else if (this.isSsiOctaveTab) {
        Plotly.purge("ssiOctaveFreqChart");
        Plotly.purge("ssiOctaveDampChart");
        Plotly.purge("ssiOctClustChart");
      } else {
        Plotly.purge("ssiFreqChart");
        Plotly.purge("ssiDampingChart");
        Plotly.purge("ssiClChart");
        Plotly.purge("ssiIfChart");
        Plotly.purge("ssiIfHist");
      }
    },
    setData() {
      let items = this.allDatas;

      if (items) {
        if (this.isFftTab) {
          if (
            !items.animate ||
            items.animate === undefined ||
            Object.keys(items.animate).length === 0
          ) {
            this.fftClDatas = [];
          } else {
            this.fftClDatas = items.animate;
          }

          if (items.fft_avg != null) {
            let fftAvgChart = [];
            for (let i = 0; i < items.fft_avg.data.length; i++) {
              let item = items.fft_avg.data[i];

              fftAvgChart.push({
                x: item.x,
                y: item.y,
                name: item.name,
                type: "scatter",
                mode: "lines",
                line: { width: 1 },
              });
            }
            this.drawLineChart(
              "fftAvgChart",
              fftAvgChart,
              {
                showlegend: false,
              },
              null,
              "Hz"
            );
          }

          if (items.fft_peak != null) {
            let fftPeakChart = [];
            for (let i = 0; i < items.fft_peak.data.length; i++) {
              let item = items.fft_peak.data[i];
              // let date = item.x.substring(0, 4) + '-' + item.x.substring(4, 6) + '-' + item.x.substring(6)
              let date = item.x.substring(4, 6) + "-" + item.x.substring(6, 8);

              fftPeakChart.push({
                x: [date],
                y: [item.y],
                type: "scatter",
                mode: "markers",
                marker: {
                  size: 8,
                  color: item.color,
                },
              });
            }
            this.drawDateChart(
              "fftPeakChart",
              fftPeakChart,
              {
                showlegend: false,
              },
              "Hz"
            );
          }

          if (items.fft_cl != null) {
            let fftClChart = [
              {
                x: [],
                y: [],
                type: "scatter",
                mode: "markers",
                marker: {
                  size: [],
                  color: [],
                },
              },
            ];
            for (let i = 0; i < items.fft_cl.chart.data.length; i++) {
              let item = items.fft_cl.chart.data[i];
              fftClChart[0].x.push(item[0]);
              fftClChart[0].y.push(item[1]);
              fftClChart[0].marker.size.push(8);
              fftClChart[0].marker.color.push(item[2]);
            }
            this.drawDefaultChart(
              "fftClChart",
              fftClChart,
              {
                showlegend: false,
              },
              "Hz"
            );

            this.clusterHistogramDatas = items.fft_cl.histogram;
            for (let i = 0; i < items.fft_cl.histogram.length; i++) {
              let item = items.fft_cl.histogram[i];

              this.clusterHistogramOptions.push({
                value: i,
                text: item.name,
              });
            }
            if (items.fft_cl.histogram.length > 0) {
              this.clusterHistogramIdx = 0;
              this.changeClusterHistogramData();
            }

            this.fftClStatGridOptions.columnDefs = [
              { headerName: "Cluster #", field: "cluster_no" },
              { headerName: "Mean(Hz)", field: "freq_mean" },
              { headerName: "STD(Hz)", field: "freq_std" },
              { headerName: "MAX(Hz)", field: "freq_max" },
              { headerName: "MIN(Hz)", field: "freq_min" },
              { headerName: "Mean(Amp)", field: "amp_mean" },
              { headerName: "STD(Amp)", field: "amp_std" },
              { headerName: "MAX(Amp)", field: "amp_max" },
              { headerName: "MIN(Amp)", field: "amp_min" },
            ];
            this.fftClStatGridOptions.api.setColumnDefs(
              this.fftClStatGridOptions.columnDefs
            );
            this.fftClStatGridOptions.api.setRowData(items.fft_cl_stat);
          }
        } else if (this.isSsiOctaveTab) {
          this.ssiOctaveGridOptions.columnDefs = [
            { headerName: "날짜", field: "time" },
            { headerName: "Frequency", field: "f" },
            { headerName: "Damping", field: "c" },
          ];
          this.ssiOctaveGridOptions.api.setColumnDefs(
            this.ssiOctaveGridOptions.columnDefs
          );
          this.ssiOctaveGridOptions.api.setRowData(items.ssi_oct_grid);
          let ssiOctaveFreqChart = [];
          let ssiOctaveDampChart = [];
          for (let i = 0; i < items.ssi_oct_chart.time.length; i++) {
            for (let j = 0; j < items.ssi_oct_chart.f[i].length; j++) {
              ssiOctaveFreqChart.push({
                x: [items.ssi_oct_chart.time[i]],
                y: [items.ssi_oct_chart.f[i][j]],
                type: "scatter",
                mode: "markers",
                marker: {
                  size: 8,
                  color: "green",
                },
              });
              ssiOctaveDampChart.push({
                x: [items.ssi_oct_chart.time[i]],
                y: [items.ssi_oct_chart.c[i][j]],
                type: "scatter",
                mode: "markers",
                marker: {
                  size: 8,
                  color: "green",
                },
              });
            }
          }
          this.drawDateChart(
            "ssiOctaveFreqChart",
            ssiOctaveFreqChart,
            {
              showlegend: false,
            },
            ""
          );
          this.drawDateChart(
            "ssiOctaveDampChart",
            ssiOctaveDampChart,
            {
              showlegend: false,
            },
            ""
          );

          // SSI Octave 클러스터링 차트
          let ssiOctClustChart = [
            {
              x: [],
              y: [],
              type: "scatter",
              mode: "markers",
              marker: {
                size: [],
                color: [],
              },
            },
          ];
          for (let i = 0; i < items.ssi_oct_clust_chart.data.length; i++) {
            let item = items.ssi_oct_clust_chart.data[i];
            ssiOctClustChart[0].x.push(item[0]);
            ssiOctClustChart[0].y.push(item[1]);
            ssiOctClustChart[0].marker.size.push(8);
            ssiOctClustChart[0].marker.color.push(item[2]);
          }
          this.drawDefaultChart(
            "ssiOctClustChart",
            ssiOctClustChart,
            {
              showlegend: false,
            },
            "Hz"
          );
        } else {
          let ssiFreqChart = [];
          for (let i = 0; i < items.ssi_freq_chart.data.length; i++) {
            let item = items.ssi_freq_chart.data[i];
            // let date = item.x.substring(0, 4) + '-' + item.x.substring(4, 6) + '-' + item.x.substring(6)
            let date = item.x.substring(4, 6) + "-" + item.x.substring(6, 8);

            ssiFreqChart.push({
              x: [date],
              y: [item.y],
              type: "scatter",
              mode: "markers",
              marker: {
                size: 8,
                color: item.color,
              },
            });
          }
          this.drawDateChart(
            "ssiFreqChart",
            ssiFreqChart,
            {
              showlegend: false,
            },
            "Hz"
          );

          let ssiDampingChart = [];
          for (let i = 0; i < items.ssi_damping_chart.data.length; i++) {
            let item = items.ssi_damping_chart.data[i];
            // let date = item.x.substring(0, 4) + '-' + item.x.substring(4, 6) + '-' + item.x.substring(6)
            let date = item.x.substring(4, 6) + "-" + item.x.substring(6, 8);

            ssiDampingChart.push({
              x: [date],
              y: [item.y],
              type: "scatter",
              mode: "markers",
              marker: {
                size: 8,
                color: item.color,
              },
            });
          }
          this.drawDateChart(
            "ssiDampingChart",
            ssiDampingChart,
            {
              showlegend: false,
            },
            "ξ"
          );

          let ssiClChart = [
            {
              x: [],
              y: [],
              type: "scatter",
              mode: "markers",
              marker: {
                size: [],
                color: [],
              },
            },
          ];
          for (let i = 0; i < items.ssi_cl_chart.data.length; i++) {
            let item = items.ssi_cl_chart.data[i];
            ssiClChart[0].x.push(item[0]);
            ssiClChart[0].y.push(item[1]);
            ssiClChart[0].marker.size.push(8);
            ssiClChart[0].marker.color.push(item[2]);
          }
          this.drawDefaultChart(
            "ssiClChart",
            ssiClChart,
            {
              showlegend: false,
            },
            "Hz",
            "ξ"
          );

          this.ssiClStatGridOptions.columnDefs = [
            { headerName: "Cluster #", field: "cluster_no" },
            { headerName: "Mean(Hz)", field: "freq_mean" },
            { headerName: "STD(Hz)", field: "freq_std" },
            { headerName: "MAX(Hz)", field: "freq_max" },
            { headerName: "MIN(Hz)", field: "freq_min" },
            { headerName: "Mean(ξ)", field: "damping_mean" },
            { headerName: "STD(ξ)", field: "damping_std" },
            { headerName: "MAX(ξ)", field: "damping_max" },
            { headerName: "MIN(ξ)", field: "damping_min" },
          ];
          this.ssiClStatGridOptions.api.setColumnDefs(
            this.ssiClStatGridOptions.columnDefs
          );
          this.ssiClStatGridOptions.api.setRowData(items.ssi_cl_stat);

          let ssiIfChart = [];
          for (let i = 0; i < items.ssi_if.init_data.y.length; i++) {
            let item = items.ssi_if.init_data.y[i];

            ssiIfChart.push({
              x: items.ssi_if.init_data.x,
              y: item.data,
              name: item.name,
              type: "scatter",
              mode: "lines",
              line: { width: 1 },
            });
          }

          ssiIfChart.push({
            x: [],
            y: [],
            type: "scatter",
            mode: "markers",
            marker: {
              size: 8,
            },
          });

          for (let i = 0; i < items.ssi_if.data.length; i++) {
            let item = items.ssi_if.data[i];
            ssiIfChart[ssiIfChart.length - 1].x.push(item.x);
            ssiIfChart[ssiIfChart.length - 1].y.push(item.y);
          }
          this.drawDualChart("ssiIfChart", ssiIfChart, {
            showlegend: false,
          });

          let ssiIfHist = [
            {
              x: [],
              y: [],
              type: "scatter",
              mode: "lines+markers",
              line: { width: 1 },
              marker: {
                size: 8,
              },
            },
          ];
          for (let i = 0; i < items.ssi_if_hist.length; i++) {
            let item = items.ssi_if_hist[i];
            // let date = item.x.substring(0, 4) + '-' + item.x.substring(4, 6) + '-' + item.x.substring(6)
            let date = item.x.substring(5);
            ssiIfHist[0].x.push(date);
            ssiIfHist[0].y.push(item.y);
          }
          this.drawDateChart("ssiIfHist", ssiIfHist, {
            showlegend: false,
          });
        }
      }
    },
    changeClusterHistogramData() {
      Plotly.purge("fftClHistogram");
      let item = this.clusterHistogramDatas[this.clusterHistogramIdx];
      let fftClHistogram = [
        {
          x: item.x,
          y: item.y,
          name: item.name,
          type: "bar",
          marker: {
            color: "rgba(255, 100, 102, 0.7)",
            line: {
              color: "rgba(255, 100, 102, 1)",
              width: 1,
            },
          },
          opacity: 0.75,
          // xbins: {
          //   end: 4,
          //   size: 0.06,
          //   start: -3.2
          // }
        },
      ];
      this.drawDefaultChart(
        "fftClHistogram",
        fftClHistogram,
        {
          showlegend: false,
        },
        "Hz"
      );
    },
    drawDefaultChart(id, dataArr, options, xTitle, yTitle) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);

      layout.margin = {
        l: 80,
        r: 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = false;
      layout.xaxis.title = xTitle;
      layout.yaxis.title = yTitle;

      if (options.barmode) {
        layout.barmode = options.barmode;
      }
      Plotly.newPlot(id, data, layout);
    },
    drawLineChart(id, dataArr, param, range, xTitle) {
      var data = dataArr;
      var layout = chartUtil.setDefaultLayout(id);
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      layout.xaxis.title = xTitle;
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    drawDateChart(id, dataArr, param, yTitle) {
      var data = dataArr;
      var layout = chartUtil.setDefaultDateLayout(id);
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      layout.yaxis.title = yTitle;
      layout.xaxis.automargin = true;
      Plotly.newPlot(id, data, layout);
    },
    drawDualChart(id, dataArr, param, range) {
      var data = dataArr;
      var layout = chartUtil.setDualAxisLayout(id, {
        datacnt:
          dataArr[0].x != null && dataArr[0].x.length > 0
            ? dataArr[0].x.length
            : dataArr[0].y.length,
        showxaxiscnt: 4,
        annotation: param.annotation,
      });
      layout.margin = {
        l:
          utils.chkNull(param.annotation) !== null &&
          utils.chkNull(param.annotation.yaxis) !== null
            ? 80
            : 50,
        r: utils.chkNull(param.showlegend, true) ? 80 : 50,
        t: 20,
        b: 30,
        pad: 0,
      };
      layout.showlegend = utils.chkNull(param.showlegend, true);
      if (utils.chkNull(range) !== null) {
        if (
          utils.chkNull(range.x) !== null &&
          (range.x.min !== 0 || range.x.max !== 0)
        ) {
          layout.xaxis.range = [range.x.min, range.x.max];
        }
        if (
          utils.chkNull(range.y) !== null &&
          (range.y.min !== 0 || range.y.max !== 0)
        ) {
          layout.yaxis.range = [range.y.min, range.y.max];
        }
        if (
          utils.chkNull(range.y2) !== null &&
          (range.y2.min !== 0 || range.y2.max !== 0)
        ) {
          layout.yaxis2.range = [range.y2.min, range.y2.max];
        }
      }
      Plotly.newPlot(id, data, layout);
    },
    reCheckAnalysis() {
      this.setConfirmTitle("재분석");
      this.$bvModal
        .msgBoxConfirm(
          "재분석을 진행하면 기존 분석 이력은 삭제 됩니다. 재분석을 진행하시겠습니까?",
          this.getConfirmOptions
        )
        .then((value) => {
          if (value) {
            if (this.search.stid === null && this.search.device === null)
              return;

            var reqBody = {
              st_id: this.search.stid,
              st_time: moment(this.search.startDate).format("YYYYMMDD"),
              ed_time: moment(this.search.endDate).format("YYYYMMDD"),
            };

            this.setSelectedDataStid(this.search.stid);
            this.setSelectedDataStartDate(this.search.startDate);
            this.setSelectedDataEndDate(this.search.endDate);

            this.search.btnDisabled = true;
            this.LoadYn = true;

            this.$http
              .post("/analysisHistory/reCheckAnalysis", reqBody, {
                timeout: 600000,
              })
              .then((res) => {
                this.search.btnDisabled = false;
                this.LoadYn = false;

                if (res.data.resultyn !== "Y") {
                  this.setAlertTitle();
                  this.$bvModal
                    .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
                    .then((value) => {})
                    .catch((err) => {
                      console.error(err);
                    });
                }
              })
              .catch((err) => {
                this.search.btnDisabled = false;
                this.LoadYn = false;
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
#analysisHistory {
  padding: 15px;
  & .chartOptions {
    & .row {
      height: 50px;
      & .col {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        & label {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #b4b7bd;
          width: 100px;
          height: 100%;
          margin-bottom: 0;
        }
        & input,
        & select {
          width: 200px;
        }
      }
    }
  }
  & .searchBox {
    justify-content: space-between;
    border-radius: 5px;
    & > div:first-child {
      & > label {
        display: flex;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }
  }
  & .main-body {
    height: calc(100vh - 120px);
    overflow-y: auto;

    & .sub-title {
      color: #fff;
    }
  }
  & .chartarea {
    & .card {
      & .card-header {
        padding: 6px 15px 8px;
        border-bottom: 1px solid #404656;
        border-top-left-radius: 0;

        & h6 {
          font-size: 15px;
          line-height: unset;
          justify-content: center;
        }
      }
      & .card-body {
        & .graph {
          height: calc(100% - 35px);
        }
      }
    }
  }
  & div.ag-theme-balham.grid {
    height: calc(100% - 40px) !important;
    padding: 5px;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  & .tabBtn {
    width: 130px;
    height: 35px;
    background-color: transparent;
    color: #555;
    border: 1px solid #404656;
    border-bottom: none;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    font-size: 16px;
    outline: none;
  }
  & .tabBtn:hover {
    font-weight: bold;
  }
  & .tabBtn_active {
    color: #fff;
    font-weight: bold;
  }
  & .panelTitle {
    border: 1px solid #404656;
    border-bottom: none;
    color: #fff;
    font-size: 13px;
    margin: 5px 3px 0 3px;
    padding: 5px;
  }
  & .panelContent {
    border: 1px solid #404656;
    margin: 0 3px 5px 3px;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis-history/AnalysisHistory.vue